export { default as GenericErrorPage } from './generic-error-page';
